import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store/index.js';

import ViewLogin    from '@/views/ViewLogin.vue';
import ViewResetPassword from '@/views/ViewResetPassword';

import ViewProfile from '@/views/ViewProfile.vue';

import ViewPracticeModes            from '@/views/ViewPracticeModes.vue';
import ViewPracticePhonemicVowel    from '@/views/ViewPracticePhonemicVowel.vue';
import ViewPracticeResults          from '@/views/ViewPracticeResults.vue';
import ViewPracticePhonemicConsonant    from '@/views/ViewPracticePhonemicConsonant.vue';
import ViewPracticePhoneticVowel    from '@/views/ViewPracticePhoneticVowel.vue';
import ViewPracticePhoneticConsonant from '@/views/ViewPracticePhoneticConsonant.vue';
import ViewPracticePhoneticTranscription from '@/views/ViewPracticePhoneticTranscription.vue';

import ViewAnalytics                from '@/views/ViewAnalytics.vue';
import ViewAnalyticsPractice        from '@/views/ViewAnalyticsPractice.vue';
import ViewAnalyticsCorrectness     from '@/views/ViewAnalyticsCorrectness.vue';
import ViewAnalyticsPerfection      from '@/views/ViewAnalyticsPerfection.vue';

import ViewChallenge            from    '@/views/ViewChallenge.vue';
import ViewChallengeFlow        from    '@/views/ViewChallengeFlow.vue';
import ViewChallengeSelectUser  from    '@/views/ViewChallengeSelectUser.vue';
import ViewChallengeSelectMode  from    '@/views/ViewChallengeSelectMode.vue';
import ViewChallengeList        from    '@/views/ViewChallengeList.vue';
import ViewChallengeRequests    from    '@/views/ViewChallengeRequests.vue';
import ViewChallengeResults     from    '@/views/ViewChallengeResults.vue';
import ViewChallengePractice    from    '@/views/ViewChallengePractice.vue';
import ViewChallengeLeaderboard from    '@/views/ViewChallengeLeaderboard.vue';

const routes = [
    {
        path: '/login',
        component: ViewLogin,
        meta: {
            title: 'Giriş',
        }
    },

    {
        path: '/reset-password',
        component: ViewResetPassword,
        meta: {
            title: 'Şifre Sıfırlama',
        },
    },

    {
        path: '/profile',
        component: ViewProfile,
        meta: {
            title: 'Profil ve Ayarlar',
        },
    },

    {
        path: '/practice-modes',
        component: ViewPracticeModes,
        meta: {
            title: 'Pratik Modları',
        },
    },

    {
        path: '/practice/phonemic-vowel',
        component: ViewPracticePhonemicVowel,
        meta: {
            title: 'Ünlü Özellikleri',
        },
    },

    {
        path: '/practice-results',
        component: ViewPracticeResults,
        meta: {
            title: 'Pratik Sonuçları',
        },
    },

    {
        path: '/practice/phonemic-consonant',
        component: ViewPracticePhonemicConsonant,
        meta: {
            title: 'Ünsüz Özellikleri',
        },
    },
    
    {
        path: '/practice/phonetic-vowel',
        component: ViewPracticePhoneticVowel,
        meta: {
            title: 'Ünlü Değişkeleri',
        },
    },

    {
        path: '/practice/phonetic-consonant',
        component: ViewPracticePhoneticConsonant,
        meta: {
            title: 'Ünsüz Değişkeleri',
        },
    },

    {
        path: '/practice/phonetic-transcription',
        component: ViewPracticePhoneticTranscription,
        meta: {
            title: 'Fonetik Transkripsiyon',
        },
    },

    {
        path: '/analytics',
        component: ViewAnalytics,
        meta: {
            title: 'Analitikler',
        },
    },

    {
        path: '/analytics/practice',
        component: ViewAnalyticsPractice,
        meta: {
            title: 'Pratik Analitikleri',
        }
    },

    {
        path: '/analytics/correctness',
        component: ViewAnalyticsCorrectness,
        meta: {
            title: 'Doğruluk Analitikleri',
        },
    },

    {
        path: '/analytics/perfection',
        component: ViewAnalyticsPerfection,
        meta: {
            title: 'Kusursuzluk Analitikleri',
        },
    },

    {
        path: '/challenge',
        component: ViewChallenge,
        meta: {
            title: 'Meydan Okuma',
        },
    },

    {
        path: '/challenge/flow',
        component: ViewChallengeFlow,
        meta: {
            title: 'Meydan Okuma İşleyiş',
        },
    },

    {
        path: '/challenge/select-user',
        component: ViewChallengeSelectUser,
        meta: {
            title: 'Birine Meydan Oku',
        },
    },

    {
        path: '/challenge/select-mode',
        component: ViewChallengeSelectMode
    },

    {
        path: '/challenge/list',
        component: ViewChallengeList,
        meta: {
            title: 'Meydan Okuma Listesi',
        },
    },

    {
        path: '/challenge/requests',
        component: ViewChallengeRequests,
        meta: {
            title: 'Meydan Okuma İstekleri',
        },
    },

    {
        path: '/challenge/results',
        component: ViewChallengeResults,
        meta: {
            title: 'Meydan Okuma Sonuçları',
        },
    },

    {
        path: '/challenge/practice',
        component: ViewChallengePractice,
        meta: {
            title: 'Meydan Okuma Pratiği',
        },
    },

    {
        path: '/challenge/leaderboard',
        component: ViewChallengeLeaderboard,
        meta: {
            title: 'Liderlik Tablosu',
        },
    },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Prevent access without user session.
// Inject user session from local storage to vuex, allowing new tabs to retain info.
router.beforeEach((to, from) => {
    // Allow routing if destination is login.
    if(to.fullPath == '/login' ||
       to.path == '/reset-password'){
        return true;
    }

    // Check if user session exists in local storage.
    let localUserSession = JSON.parse(window.localStorage.getItem('userSession'));
    
    if(!localUserSession){
        console.log("ROUTER/USER_SESSION_CHECK::INV_LOCAL_USERS_SESSION_01");
        router.push('/login');
        return false;
    }

    if(!localUserSession.id){
        console.log("ROUTER/USER_SESSION_CHECK::INV_LOCAL_USERS_SESSION_02");
        router.push('/login');
        return false;
    }

    // Update vuex user session state with the local user session.
    console.log("ROUTER/USER_SESSION_CHECK::UPDATED_VUEX_FROM_LOCAL_STORAGE");
    store.commit('setUserSession', localUserSession);

    // If request is to / root path, redirect to practice modes.
    if(to.fullPath == '/'){
        router.push('/practice-modes');
    }

    return true;
}),

// Prevent direct access to practice mode routes.
router.beforeEach((to, from) => {

    let forbiddenPaths = [
        '/practice/phonemic-vowel',
        '/practice/phonetic-vowel',
        '/practice/phonemic-consonant',
        '/practice/phonetic-consonant',
    ];

    if(forbiddenPaths.includes(to.fullPath.toLowerCase())){

        if(!store.state.practiceSession){
            console.log("ROUTER/PREVENT_DIRECT_ACCESS_TO_PRACTICE_MODE_ROUTES");
            router.push('/practice-modes');
        }
    }
});

// Prevent direct access to result routes.
router.beforeEach((to, from) => {
    return;
    let forbiddenToPaths = [
        '/practice-results',
        '/challenge/results'
    ];

    let allowedFromPaths = [
        '/practice/phonemic-vowel',
        '/practice/phonetic-vowel',
        '/practice/phonemic-consonant',
        '/practice/phonetic-consonant',
    ];

    if(forbiddenToPaths.includes(to.fullPath.toLowerCase()) && allowedFromPaths.includes(from.fullPath.toLowerCase()) !== true){
        console.log("ROUTER/PREVENT_DIRECT_ACCESS_TO_RESULT_ROUTES");
        router.push('/practice-modes');
    }
});

// Reset from practice mode routes.
router.afterEach((to, from) => {

    let pathsResetFrom = [
        '/practice/phonemic-vowel',
        '/practice/phonetic-vowel',
        '/practice/phonemic-consonant',
        '/practice/phonetic-consonant',
    ];

    let pathsExcludeTo = [
        '/practice-results',
        '/challenge/results',
    ];

    if(pathsResetFrom.includes(from.fullPath.toLowerCase()) && pathsExcludeTo.includes(to.fullPath.toLowerCase()) !== true){
        
        console.log("ROUTER/RESET_FROM_PRACTICE_MODE_ROUTES");

        store.commit('setChallengeSession', null);

        store.commit('setPracticeSession',  null);
        store.commit('setQuestionSet',      null);
        store.commit('setAnswerDataSchema', null);
        store.commit('setFeedbackData',     null);
        store.commit('resetPracticeStats');
    }

});


// Reset from result routes.
router.afterEach((to, from) => {

    let pathsResetFrom = [
        '/practice-results',
        '/challenge/results'
    ];

    // Do not reset practice data if restarted from practice results.
    if(store.state.router.practiceRestart){
        store.commit('setRouterPracticeRestart', false);
        return true;
    }

    if(pathsResetFrom.includes(from.fullPath.toLowerCase())){
        
        console.log("ROUTER/RESET_FROM_RESULT_ROUTES");

        store.commit('setChallengeSession', null);

        store.commit('setPracticeSession',  null);
        store.commit('setQuestionSet',      null);
        store.commit('setAnswerDataSchema', null);
        store.commit('setFeedbackData',     null);
        store.commit('resetPracticeStats');
    }

});

// Prevent navigating to /challenge/select-mode if no user is selected.
router.beforeEach((to, from) => {

    if(to.fullPath.toLowerCase() === '/challenge/select-mode'){
        if(!store.state.selectedUser){
            console.log("ROUTER/PREVENT_TO_SELECT_MODE");
            router.push('/practice-modes');
        }
    }
});

// Reset the selected user when navigating from challenge select mode.
router.afterEach((to, from) => {
    
    if(from.fullPath.toLowerCase() === '/challenge/select-mode'){
        console.log("ROUTER/RESET_SELECTED_USER_FROM_SELECT_MODE");
        store.commit('setSelectedUser', null);
    }
});

// Reset the selected user when navigating from select user except select mode.
router.afterEach((to, from) => {
    if(to.fullPath.toLowerCase() === '/challenge/select-mode'){
        return true;
    }

    if(from.fullPath.toLowerCase() === '/challenge/select-user'){
        console.log("ROUTER/RESET_SELECTED_USER_FROM_SELECT_USER");
        store.commit('setSelectedUser', null);
    }
});

router.beforeEach((to, from) => {
    console.log("ROUTER/SCROLL_TO_TOP");
    window.scrollTo(0, 0);
});

// Change document title.
router.afterEach((to, from) => {
    console.log("ROUTER/CHANGE_DOCUMENT_TITLE");
    document.title = `${to.meta.title} | Foneturk`;
})

export default router
